<template>
  <div class="home">
    <!--<h2>This is default home page</h2>-->
    <!--<h2><router-link to="about">About</router-link></h2>-->
    <!--<h2><router-link to="changUser">Change User</router-link></h2>-->
    <!--<h2><router-link to="/prm/list">Project Report Lit</router-link></h2>-->
    <!--<h2><router-link to="/prm/new">Project Report Add</router-link></h2>-->
    <!--<h2><router-link to="/prm/dtl">Project Report Detail</router-link></h2>-->
    <!--<img alt="Vue logo" src="../assets/images/logo.png">-->
    <el-container>
      <el-aside :style="{width:leftWidth+'px'}"><left-aside /></el-aside>
      <el-main><router-view v-if="isRouterAlive" /></el-main>
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LeftAside from './component/left';
import eventBus from '../libs/eventBus';
export default {
  name: 'Home',
  data () {
    return {
      leftWidth: 244,
      isRouterAlive: true
    };
  },
  components: {
    LeftAside
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  mounted () {
    eventBus.$on('reloadAll', (e) => {
      this.reload();
    });
    eventBus.$on('leftWidthChange', (e) => {
      this.leftWidth = e;
    });
  },
  destroyed () {
    eventBus.$off('reloadAll');
    eventBus.$off('leftWidthChange');
  }
};
</script>
<style lang="scss">
  .home{
    height: 100%;
  }
  .el-container{
    height: 100%;
  }
  .el-aside {
    color: #333;
    text-align: center;
    transition: width 0.3s ease-in-out;
  }

  .el-main {
    width: 100%;
    color: #333;
    padding-top: 0;
    height: 100%;
    overflow-x:hidden
  }

  body > .el-container {
    margin-bottom: 40px;
  }
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
  }
  .el-table__body tr,
  .el-table__body td {
    padding: 0;
    height: 40px;
  }
</style>
